import { CustomAxios } from "@shared/api/axiosClient";

import type { Schemas } from "@shared/api/types";

export type SignInCredentials = Schemas["SignInDTO"];
export type SignInResult = Schemas["JwtDTO"];
export type WeekTimesheetStatus = Schemas["ValidateChargedHourInWeekDTO"];

/**
 * Payload de registro. Sin tipo generado a proposito: el endpoint que consume
 * `register` no existe en el backend (ver el comentario sobre POST /v1/auth).
 */
export interface RegisterPayload {
  name?: string;
  surname?: string;
  email?: string;
  password?: string;
}

// Capa HTTP del dominio auth. Funciones puras: entran params, sale Promise<data>.
// La auth y el Accept-Language los adjunta el interceptor axios compartido.

// Login: devuelve el usuario (incluye token).
export const signIn = (credentials: SignInCredentials): Promise<SignInResult> =>
  CustomAxios.post("auth/signin", credentials).then(({ data }) => data);

// Registro de usuario. Antes apuntaba a http://localhost:8091 hardcodeado;
// ahora usa el cliente compartido (baseURL + interceptor).
//
// OJO: este POST no tiene endpoint. AuthController solo mapea /signin y /logout, y
// `/v1/auth` no aparece en el contrato capturado. La pantalla de registro
// (/authentication/sign-up) envia contra una ruta inexistente. Se deja tal cual: darlo
// de baja o implementarlo en el backend es una decision de producto, no de la migracion.
export const register = (payload: RegisterPayload): Promise<unknown> =>
  CustomAxios.post("auth", payload).then(({ data }) => data);

// Indica si el usuario tiene facturas sin enviar ("Found" / otro).
export const checkUnsentInvoice = (): Promise<string> =>
  CustomAxios.get("invoices/check-unsent").then(({ data }) => data);

// Estado de la carga de horas de la semana actual.
export const validateCurrentWeekTimesheet = (): Promise<WeekTimesheetStatus> =>
  CustomAxios.get("time-entry/validate-timesheet/week-current").then(({ data }) => data);
